import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIModule } from '../common/ui.module';

import { DashboardMetricComponent } from './metric/dashboard-metric.component';
import { DashboardMetricContentSingleComponent } from './metric/dashboard-metric-content-single.component';
import { DashboardMetricContentTop3Component } from './metric/dashboard-metric-content-top3.component';
import { DashboardMetricBarComponent } from './metric/dashboard-metric-bar.component';
import { DashboardMetricContentPairComponent } from './metric/dashboard-metric-content-pair.component';
import { DashboardMetricContentPlaceholderComponent } from './metric/dashboard-metric-content-placeholder.component';

@NgModule({
    imports: [
        CommonModule,
        UIModule,
    ],
    declarations: [
        DashboardMetricComponent,
        DashboardMetricContentSingleComponent,
        DashboardMetricContentTop3Component,
        DashboardMetricContentPairComponent,
        DashboardMetricContentPlaceholderComponent,
        DashboardMetricBarComponent,
    ],
    exports: [
        DashboardMetricComponent,
        DashboardMetricContentSingleComponent,
        DashboardMetricContentTop3Component,
        DashboardMetricContentPairComponent,
        DashboardMetricContentPlaceholderComponent,
        DashboardMetricBarComponent,
    ],
    providers: [

    ],
})
export class DashboardModule {

}
